<template>
	<div v-if="show" @click.self="dismissModal()" class="fixed pin z-50 overflow-hidden bg-smoke-light flex">
		<div class="relative bg-grey-lightest w-full max-w-lg m-auto flex-col flex rounded m-8 overflow-hidden max-h-screen-90 ">
			<div class="w-full bg-green-light py-1"></div>
			<div class="flex py-2 m-2 px-4">
				<div class="flex-1 text-left">
					<p class="text-lg font-extrabold">Lägg till extra analyser</p>
				</div>
				<div class="flex-1 mr-2">
					<button @click="dismissModal()" class="float-right text-grey hover:text-grey-darker">
						<svg class="fill-current h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
					</button>
				</div>
			</div>

			<div class="pb-8">
				<p class="text-left leading-normal mx-6">
					Filen som laddas upp måste ha filtypen .xlsx.<br>
					Och den måste innehålla som minst följande kolumner:<br>
					<strong>X, Y, Provnr, Kalk 50 procent CaO, Magnesiumbehov, Avkastningsminskning</strong><br>
					<br>
					<b>Obs! Ladda upp filen som sista steget innan utskrift görs!</b>
				</p>
				<div class="pt-4">
					<input type="file" id="file" ref="myFiles" class="custom-file-input" @change="readExcelFile">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import slugify from 'slugify'
import XLSX from 'xlsx';

import { mapGetters } from 'vuex'

export default {

	data() {
		return {
			show: false,
		}
	},

	mounted() {
		bus.$on('open-add-extra-analysis-modal', this.openModal)
		bus.$on('close-add-extra-analysis-modal', this.dismissModal)
	},

    beforeDestroy() {
        bus.$off('open-add-extra-analysis-modal')
        bus.$off('close-add-extra-analysis-modal')
	},
	
	computed: {

		...mapGetters({
			storeHasExtraAnalyses:	'analysis/hasExtraAnalyses',
		}),

},

	methods: {
		openModal() {
			this.show = true
			document.getElementById("body").className = "overflow-y-hidden";
			bus.$emit('deselect')
		},
		
		dismissModal() {
			this.show = false
			document.getElementById("body").className = "";
		},
		
		readExcelFile() {
			let files = this.$refs.myFiles.files
			if (!files || files.length == 0) return;

			let file = files[0];
			if(file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {

				var fileReader = new FileReader();
				fileReader.onload = (e) => {
					var filename = file.name;
					var binary = "";
					var bytes = new Uint8Array(e.target.result);
					var length = bytes.byteLength;
					for (var i = 0; i < length; i++) {
						binary += String.fromCharCode(bytes[i]);
					}
					const oFile = XLSX.read(binary, {type: 'binary', cellDates:true, cellStyles:true});

					this.parseSheetData(oFile.Sheets[Object.keys(oFile.Sheets)[0]])
				};
				fileReader.readAsArrayBuffer(file);

			} else {
				alert('Filformatet måste vara .xlsx')
			}
		},

		parseSheetData(sheet) {
			let jsonSheet = XLSX.utils.sheet_to_json(sheet, {
				header: 1,
				blankrows: false
			})

			let headers = jsonSheet.splice(0,1)[0].map(col => {
				col = col.trim()
				let slug = slugify(col.replace(/-| /g, "_").toLowerCase())

				let legendTitle = col
				if(col == 'Kalk 50 procent CaO') {
					legendTitle = 'ton/ha'
					col = 'Kalk 50% CaO'
				} else if(col == 'Magnesiumbehov') {
					legendTitle = 'Kg/ha'
				} else if(col == 'Avkastningsminskning') {
					legendTitle = 'Kg/ha'
				}

				return {
					title: col,
					legendTitle: legendTitle,
					slug: slug,
				}
			})

			// These columns are needed
			let neededHeaders = ['X', 'Y', 'Provnr', 'Kalk 50% CaO', 'Magnesiumbehov', 'Avkastningsminskning']

			// Make sure the headers have all the needed columns and that they are spelled correctly
			if(headers.map(obj => obj.slug).includes(neededHeaders.map(header => slugify(header.replace(/-| /g, "_").toLowerCase())))) {
				alert('Filen måste innehålla:\n' + neededHeaders.join(', ') + '\n\nProva ladda upp en ny fil med rätt kolumner.\n')
				return;
			}

			let result = jsonSheet.map(row => {
				let data = {}
				headers.forEach((obj, index) => {
					if(obj.title == 'Kalk 50% CaO') {
						data[obj.slug] = parseFloat(row[index]).toFixed(1)
					} else if(obj.title == 'Magnesiumbehov') {
						data[obj.slug] = parseInt(row[index])
					} else if(obj.title == 'Avkastningsminskning') {
						data[obj.slug] = parseInt(row[index])
					} else {
						data[obj.slug] = row[index]
					}
				});
				return data
			})

			if(!this.storeHasExtraAnalyses) {
				this.$store.dispatch("analysis/APPEND_ADDITIONAL_ANALYSIS_TYPES", headers.filter(header => ['Kalk 50% CaO', 'Magnesiumbehov', 'Avkastningsminskning'].includes(header.title)))
			}

			bus.$emit('add-extra-analysis', result)
			
			bus.$emit('show-notification', "Filen laddades upp", "Värdena har lagts till på proverna och kan nu skrivas ut")
			this.dismissModal()
		}
	}
}
</script>